import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableActionGroupComponent } from './table-action-group.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableActionDirective } from './table-action.directive';

const components = [MatButtonModule, MatMenuModule, MatIconModule, MatTooltipModule, RouterModule];

@NgModule({
  imports: [CommonModule, ...components],
  declarations: [TableActionGroupComponent, TableActionDirective],
  exports: [TableActionGroupComponent, TableActionDirective],
})
export class TableActionGroupModule {}
